import axios from 'axios'

export function listProductModules(params) {
  return axios.get('/api/product-modules/list', { params })
}

export function getProductModule(id) {
  return axios.get(`/api/product-modules/${id}`)
}

export function submitProductModule(data) {
  return axios.post('/api/product-modules/submit', data)
}

export function removeProductModules(ids) {
  return axios.post('/api/product-modules/remove', null, { params: { ids: ids.join(',') } })
}

export function syncProductModules() {
  return axios.post('/api/product-modules/sync')
}
